(() => {
  const selector = '[id^="tc-capture-kit"]';
  let observer;
  let stopTimer;

  const applyFix = (root = document) => {
    const captureKit = root instanceof Element && root.matches(selector) ? root : root.querySelector?.(selector);
    if (!captureKit) return false;

    captureKit.style.setProperty('z-index', '999', 'important');
    observer?.disconnect();
    clearTimeout(stopTimer);
    return true;
  };

  const start = () => {
    if (applyFix()) return;

    // Capture Kit inserts its overlay at body level. Observe only direct body
    // children and inspect the nodes actually added instead of polling forever
    // or observing the entire document subtree.
    observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node instanceof Element && applyFix(node)) return;
        }
      }
    });
    observer.observe(document.body, { childList: true });
    stopTimer = window.setTimeout(() => observer?.disconnect(), 15000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
